import React, { FC, useEffect, useState } from 'react';
import _ from 'lodash';
import { useWindowResize } from 'beautiful-react-hooks';
import { useAppStore } from '../store/AppContext';
import { AccessType } from '../types/Types';
import { useAuthStore } from '../store/AuthContext';
import { StorageHelper } from '../utils/StorageHelper';
import FooterEroski from './FooterEroski';
import FooterCaprabo from './FooterCaprabo';
import { HostProvider } from '../utils/HostProvider';

const Footer: FC = () => {
  const dataApp = useAppStore();
  const dataUser = useAuthStore();
  const { access } = dataApp;
  const [footerLink, setFooterLink] = useState<AccessType[]>([]);
  const [widthPage, setWidthPage] = useState<number>(window.innerWidth);
  const isEcommerceBot = StorageHelper.isEcommerceBot();
  const getUrlLink = (items: AccessType) => {
    if (items.url.slice(0, 1) === 'h') return items.url;
    return `/${dataApp?.lang}${items.url}`;
  };

  const isCaprabo = HostProvider.isCaprabo();

  useEffect(() => {
    if (typeof access?.footerLinks !== 'undefined') {
      setFooterLink(_.uniqWith(access?.footerLinks, _.isEqual));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [access]);

  /**
   * Ocultar Eventos de acoordion
   * */

  const slideUp = (target: HTMLElement, duration = 0) => {
    target.style.removeProperty('display');
    // const { display } = window.getComputedStyle(target);
    // eslint-disable-next-line no-console
    // console.log('slideUp', display);
    // eslint-disable-next-line no-param-reassign
    target.style.transitionProperty = 'height, margin, padding';
    // eslint-disable-next-line no-param-reassign
    target.style.transitionDuration = `${duration}ms`;
    // eslint-disable-next-line no-param-reassign
    target.style.boxSizing = 'border-box';
    // eslint-disable-next-line no-param-reassign
    target.style.height = `${target.offsetHeight}px`;
    // eslint-disable-next-line no-unused-expressions
    target.offsetHeight;
    // eslint-disable-next-line no-param-reassign
    target.style.overflow = 'hidden';
    // eslint-disable-next-line no-param-reassign
    target.style.height = String(0);
    // eslint-disable-next-line no-param-reassign
    target.style.paddingTop = String(0);
    // eslint-disable-next-line no-param-reassign
    target.style.paddingBottom = String(0);
    // eslint-disable-next-line no-param-reassign
    target.style.marginTop = String(0);
    // eslint-disable-next-line no-param-reassign
    target.style.marginBottom = String(0);
    window.setTimeout(() => {
      // eslint-disable-next-line no-param-reassign
      target.style.display = 'none';
      target.style.removeProperty('height');
      target.style.removeProperty('padding-top');
      target.style.removeProperty('padding-bottom');
      target.style.removeProperty('margin-top');
      target.style.removeProperty('margin-bottom');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
      // alert("!");
    }, duration);
  };

  /**
   * Mostrar Eventos de acoordion
   * */
  const slideDown = (target: HTMLElement, duration = 0) => {
    target.style.removeProperty('display');
    let { display } = window.getComputedStyle(target);
    /* if (display === 'none') */
    // eslint-disable-next-line no-console
    // console.log('slideDown', display);
    display = 'block';

    // eslint-disable-next-line no-param-reassign
    target.style.display = display;
    const height = target.offsetHeight;
    // eslint-disable-next-line no-param-reassign
    target.style.overflow = 'none';
    // eslint-disable-next-line no-param-reassign
    target.style.height = String(0);
    // eslint-disable-next-line no-param-reassign
    target.style.paddingTop = String(0);
    // eslint-disable-next-line no-param-reassign
    target.style.paddingBottom = String(0);
    // eslint-disable-next-line no-param-reassign
    target.style.marginTop = String(0);
    // eslint-disable-next-line no-param-reassign
    target.style.marginBottom = String(0);
    // eslint-disable-next-line no-unused-expressions
    target.offsetHeight;
    // eslint-disable-next-line no-param-reassign
    target.style.boxSizing = 'border-box';
    // eslint-disable-next-line no-param-reassign
    target.style.transitionProperty = 'height, margin, padding';
    // eslint-disable-next-line no-param-reassign
    target.style.transitionDuration = `${duration}ms`;
    // eslint-disable-next-line no-param-reassign
    target.style.height = `${height}px`;
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout(() => {
      target.style.removeProperty('height');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
    }, duration);
  };

  /**
   * Toggle Eventos de acoordion
   * */
  const slideToggle = (target: HTMLElement, duration = 500) => {
    // console.log(window.getComputedStyle(target as Element).display);
    if (window.getComputedStyle(target as Element).display === 'none') {
      return slideDown(target as HTMLElement, duration);
    }
    return slideUp(target as HTMLElement, duration);
  };

  const eventClickBarOptions = (event) => {
    event.preventDefault();
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    const cant = document.querySelector('.f2-quicklinks__container').scrollLeft;

    if (cant > 150) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      document.querySelector('.f2-quicklinks__container').scroll({
        left: cant - 150,
        behavior: 'smooth',
      });
    }
  };

  const eventClickScrollLeft = (event) => {
    event.preventDefault();
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    const cant = document.querySelector('.f2-quicklinks__container').scrollLeft;

    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    document.querySelector('.f2-quicklinks__container').scroll({
      left: cant + 150,
      behavior: 'smooth',
    });
  };

  const eventClickAcordion = (event) => {
    const l = event.target.nextSibling;
    if (window.innerWidth <= 480) {
      event.stopPropagation();
      event.preventDefault();
      slideToggle(l as HTMLElement);
      event.target.classList.toggle('open');
    } else {
      l.style.display = 'block';
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const updateSizeFnt = () => {
    // eslint-disable-next-line no-console
    // console.log(
    //   'window.innerWidth --> ',
    //   window.innerWidth,
    //   window.innerWidth <= 480,
    // );
    /**
     * Elimino los eventos asignados
     */
    document.querySelectorAll('.f2-links1__item > span').forEach((div) => {
      // eslint-disable-next-line no-unused-expressions
      div.removeEventListener('click', eventClickAcordion);
    });
    if (window.innerWidth <= 480) {
      /**
       * cierro los nodos
       */
      document.querySelectorAll('.f2-links1__item > span').forEach((div) => {
        const l = div.nextSibling;
        slideUp(l as HTMLElement);
      });

      /* document.querySelectorAll('.f2-links1__item > span').forEach((div) => {
        div.addEventListener('click', eventClickAcordion, false);
      }); */
    } else {
      /**
       * restablecer todos los elementos
       */
      document.querySelectorAll('.f2-links1__item > span').forEach((div) => {
        const l = div.nextSibling;
        slideDown(l as HTMLElement);
      });
    }
  };

  useWindowResize(() => {
    // eslint-disable-next-line no-console
    // console.log(
    //   'useWindowResize',
    //   window.innerWidth,
    //   'actual',
    //   widthPage,
    //   window.innerWidth <= 480 && widthPage >= 480,
    // );
    // window.removeEventListener('resize', updateSizeFnt);
    if (window.innerWidth <= 480 && widthPage >= 480) {
      setWidthPage(window.innerWidth);
      // window.addEventListener('resize', updateSizeFnt, false);
      document.querySelectorAll('.f2-links1__item > span').forEach((div) => {
        if (div.classList.contains('open')) {
          div.classList.toggle('open');
        }
        const l = div.nextSibling;
        slideUp(l as HTMLElement);
      });
    }
    if (window.innerWidth > 480) {
      setWidthPage(window.innerWidth);
      /**
       * restablecer todos los elementos
       */
      document.querySelectorAll('.f2-links1__item > span').forEach((div) => {
        const l = div.nextSibling;
        if (!div.classList.contains('open')) {
          div.classList.toggle('open');
        }
        slideDown(l as HTMLElement);
      });
    }
  });

  if (dataUser.user.isApp === 'false' && !isEcommerceBot) {
    if (isCaprabo) {
      return (
        <FooterCaprabo
          eventClickAcordion={eventClickAcordion}
          eventClickBarOptions={eventClickBarOptions}
          eventClickScrollLeft={eventClickScrollLeft}
          footerLink={footerLink}
          getUrlLink={getUrlLink}
        />
      );
    }
    return (
      <FooterEroski
        eventClickAcordion={eventClickAcordion}
        eventClickBarOptions={eventClickBarOptions}
        eventClickScrollLeft={eventClickScrollLeft}
        footerLink={footerLink}
        getUrlLink={getUrlLink}
      />
    );
  }
  return <></>;
};

export default Footer;
